import { render, staticRenderFns } from "./access-module.vue?vue&type=template&id=2b994869&scoped=true&"
import script from "./access-module.vue?vue&type=script&lang=ts&"
export * from "./access-module.vue?vue&type=script&lang=ts&"
import style0 from "./access-module.vue?vue&type=style&index=0&id=2b994869&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b994869",
  null
  
)

export default component.exports